import { defineComponent, reactive, ref } from 'vue';
import { tap, filter } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { ThreadingQueryPlugin } from 'src/features/serverConnector/threading';
import { AppGeneralVariables } from 'src/plugins/general/variables';
export default defineComponent({
    name: 'emoji',
    emits: [
        'add-emoji'
    ],
    setup(props, context) {
        const { thumbStyle } = AppGeneralVariables();
        const categoryList = [{
                name: 'Smileys & Emotion',
                icon: 'emoji_emotions'
            }, {
                name: 'People & Body',
                icon: 'people'
            }, {
                name: 'Animals & Nature',
                icon: 'pets'
            }, {
                name: 'Food & Drink',
                icon: 'lunch_dining'
            }, {
                name: 'Travel & Places',
                icon: 'flight'
            }, {
                name: 'Activities',
                icon: 'sports_basketball'
            }, {
                name: 'Objects',
                icon: 'straighten'
            }, {
                name: 'Symbols',
                icon: 'add'
            }, {
                name: 'Flags',
                icon: 'flag'
            }];
        // tab
        const tab = ref('Smileys & Emotion');
        /**
         * Query
         */
        const emojiList = reactive({});
        const loading = ref(false);
        function threadingEmojiCallback({ newValue }) {
            const results = newValue.results;
            const category = results[0].category;
            emojiList[category] = results;
        }
        function threadingEmojiCallbackError() {
            loading.value = false;
        }
        const { threadingTaskFunction } = ThreadingQueryPlugin('emojiData', threadingEmojiCallback, threadingEmojiCallbackError, false);
        const { subject: emojiQuery$ } = rxInitSubjectCallback();
        useObservable(emojiQuery$.pipe(filter((v) => !emojiList[v]), tap(v => {
            threadingTaskFunction({
                data: {
                    type: 'list',
                    state: 'card',
                    loading: false,
                    url: 'emoji',
                    params: {
                        filter: {
                            category: v
                        }
                    }
                },
                type: 'api'
            });
        })));
        /**
         * Initialize query of emoji
         * @param newVal Emoji category
         */
        function queryEmoji(newVal) {
            emojiQuery$.next(newVal);
        }
        // query on create
        queryEmoji(tab.value);
        /**
         * add emoji to the text
         * @param value Emoji string
         */
        function addEmoji(value) {
            context.emit('add-emoji', value);
        }
        return {
            thumbStyle,
            categoryList,
            tab,
            emojiList,
            loading,
            queryEmoji,
            addEmoji
        };
    }
});
